import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../store';
import { hideNotification } from '../store/notificationSlice';

const GlobalSnackbar: React.FC = () => {
  const dispatch = useAppDispatch();
  const { open, message, severity } = useAppSelector((state) => state.notification);

  return (
    <Snackbar
      open={open}
      autoHideDuration={severity === 'error' ? 5000 : 3000}
      onClose={() => dispatch(hideNotification())}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ top: '5px !important' }}
    >
      <Alert severity={severity} onClose={() => dispatch(hideNotification())}>{message}</Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
